// extracted by mini-css-extract-plugin
module.exports = {"Container":"Home_Container__2gE-H","Content":"Home_Content__1BYcS"};